<template>
    <span class="sportsSwitch-sportItem-tag sportsSwitch-sportItem-tag_new">
        {{ i18n.t(`sportsSlip_new${isEuroSite ? '_EURO' : ''}`) }}
    </span>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { i18n } from '@/libraries/i18n';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';

    const { isEuroSite } = storeToRefs(useFeatureToggleStore());
</script>

<style scoped lang="scss">
@import "@/scss/components/sportListItemTag";
</style>
